import { getPayloadMessage, SerializedError, serializeError } from '@/store/utils/serialize-error';
import { ProjectStateReducerCreator } from '../types';
import DuplicateProject from '@/connection/projects/duplicate-project';
import toastTrigger from '@ui/toast/toast-trigger';

const duplicateProjectReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async ({ projectUuid, channel }: { projectUuid: string; channel: number }, { rejectWithValue }) => {
      try {
        const result = await DuplicateProject({
          projectUuid,
          channel,
        });
        if ('error' in result) {
          return rejectWithValue(serializeError(result.error));
        }
        return result;
      } catch (e) {
        return rejectWithValue(serializeError(e));
      }
    },
    {
      fulfilled: (state, action) => {
        state.isProjectDuplicating = false;
        state.duplicatedProject = action.payload;
      },
      pending: (state) => {
        state.isProjectDuplicating = true;
        state.duplicatedProject = null;
      },
      rejected: (state, action) => {
        state.duplicatedProject = null;
        console.error('Error duplicating project:', action.error);
        const errMsg =
          getPayloadMessage(action.payload as SerializedError | string | undefined) || action.error?.message;
        toastTrigger(
          `<div>
              <h4 class="H4">There was an error duplicating the project.</h4>
              <p class="S1">${errMsg}</p>
            </div>`,
          {
            type: 'error',
            autoClose: 5000,
          }
        );
      },
      settled: (state) => {
        state.isProjectDuplicating = false;
      },
    }
  );
};

export default duplicateProjectReducer;
